export const ScheduleClosingSectionTestIds = {
  REJECT_ALL_BUTTON: 'schedule-closing.reject-all-button',
  REJECTION_MESSAGE_INPUT: 'schedule-closing.rejection-message-input',
  CANCEL_REJECT_BUTTON: 'schedule-closing.cancel-reject-button',
  CONFIRM_REJECT_BUTTON: 'schedule-closing.confirm-reject-button',

  getApproveButtonId: index => `schedule-closing.approve-button-${index}`,
};
